<template>
  <div class="reporting-section" v-if="hasData">
    <div class="section-header">
      <i class="material-icons section-icon">insert_chart</i>
      <h2>{{ $t('dash.reporting.section.posts.title') }} — Types &amp; Jours</h2>
    </div>

    <div class="charts-grid">
      <div class="chart-block" v-if="typeChart">
        <div class="chart-label">{{ $t('dash.label.linkedin.typePosts_graph') }}</div>
        <div class="chart-wrap">
          <Graph
            :id="`post-type-count-${pageId}`"
            :data="typeChart.data"
            :labels="typeChart.labels"
            height="200px"
            width="100%"
          />
        </div>
      </div>

      <div class="chart-block" v-if="typeEngChart">
        <div class="chart-label">{{ $t('dash.label.linkedin.typePosts_engagement_graph') }}</div>
        <div class="chart-wrap">
          <Graph
            :id="`post-type-eng-${pageId}`"
            :data="typeEngChart.data"
            :labels="typeEngChart.labels"
            height="200px"
            width="100%"
          />
        </div>
      </div>

      <div class="chart-block" v-if="dayChart">
        <div class="chart-label">{{ $t('dash.label.linkedin.dayPosts_graph') }}</div>
        <div class="chart-wrap">
          <Graph
            :id="`post-day-count-${pageId}`"
            :data="dayChart.data"
            :labels="dayChart.labels"
            height="200px"
            width="100%"
          />
        </div>
      </div>

      <div class="chart-block" v-if="dayEngChart">
        <div class="chart-label">{{ $t('dash.label.linkedin.dayPosts_engagement_graph') }}</div>
        <div class="chart-wrap">
          <Graph
            :id="`post-day-eng-${pageId}`"
            :data="dayEngChart.data"
            :labels="dayEngChart.labels"
            height="200px"
            width="100%"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Graph from './Graph.vue'

export default {
  name: 'ReportingPostTypes',
  components: { Graph },
  props: {
    stats: { type: Object, required: true },
    page: { type: Object, default: null },
  },
  computed: {
    pageId() {
      return this.page ? this.page.id : 'posttypes'
    },
    hasData() {
      return !!(this.typeChart || this.dayChart)
    },
    typeChart() {
      return this.buildBarChart(
        this.stats.page.typePosts_graph,
        this.$t('dash.reporting.publications')
      )
    },
    typeEngChart() {
      return this.buildBarChart(
        this.stats.page.typePosts_engagement_graph,
        this.$t('dash.reporting.section.engagements.title')
      )
    },
    dayChart() {
      return this.buildBarChart(
        this.stats.page.dayPosts_graph,
        this.$t('dash.reporting.publications')
      )
    },
    dayEngChart() {
      return this.buildBarChart(
        this.stats.page.dayPosts_engagement_graph,
        this.$t('dash.reporting.section.engagements.title')
      )
    },
  },
  methods: {
    buildBarChart(rawData, label) {
      if (!rawData || !rawData.length) return null
      const filtered = rawData.filter(function(r) { return r.value > 0 })
      if (!filtered.length) return null
      return {
        labels: filtered.map(function(r) { return this.$t(r.name) }.bind(this)),
        data: [{ label: label, data: filtered.map(function(r) { return r.value || 0 }), type: 'bar' }],
      }
    },
  },
}
</script>

<style scoped>
.reporting-section {
  background: #fff;
  border-radius: 5.6px;
  padding: 20px 24px;
  box-shadow: 0 2px 5.6px rgba(107,31,77,0.06);
  border: 1px solid #f1edf5;
}
.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}
.section-icon { color: #6B1F4D; font-size: 22px; }
.section-header h2 { font-size: 16px; font-weight: 700; color: #121826; margin: 0; }

.charts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}
.chart-block {
  min-width: 0;
}
.chart-label {
  font-size: 12px;
  font-weight: 600;
  color: #9ba3b7;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 10px;
}
.chart-wrap {
  height: 200px;
}
</style>
